export const SECTOR_TO_ICON = {
  Automotive: 'Automotive',
  'Business Services': 'BusinessServices',
  'Charity and Non-Profit': 'Charity',
  'Chemicals and Allied Products': 'ChemicalsAndAlliedProducts',
  Construction: 'Construction',
  'Critical Infrastructures': 'CriticalInfrastructures',
  Cryptocurrency: 'Cryptocurrency',
  Defense: 'Defense',
  Education: 'Education',
  Energy: 'Energy',
  Entertainment: 'Entertainment',
  Finance: 'Finance',
  'Food and Kindred Products': 'FoodAndKindredProducts',
  Gambling: 'Gambling',
  Government: 'Government',
  Healthcare: 'Healthcare',
  'Insurance Agents, Brokers and Service': 'InsuranceAgentsBrokersAndService',
  Journalism: 'Journalism',
  Manufacturing: 'Manufacturing',
  Media: 'Media',
  Mining: 'Mining',
  'Real Estate': 'RealEstate',
  Retail: 'Retail',
  Software: 'Technology',
  Technology: 'Technology',
  Telecommunications: 'Telecommunication',
  Tourism: 'Tourism',
  Transportation: 'Transportation'
};
